import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadCommands from './commands';
import loadBlocks from './blocks';
import { drapcodeIconsRef } from './consts';
import { icons } from 'feather-icons';
import { convertToTitleCase } from '../collectionForm/utils';

export default grapesjs.plugins.add('gjs-drapcode-icons', (editor, opts) => {
  let options = opts || {};
  let tagSet = new Set();
  let default_tags = [{ label: 'All', value: 'ALL' }];
  const feather = require('feather-icons');

  Object.entries(icons).map(([key, value]) => {
    if (value.tags.length > 0) {
      value.tags.map((tag) => {
        tagSet.add(tag);
      });
    }
  });

  [...tagSet].sort().map((tag) => {
    default_tags.push({
      label: convertToTitleCase(tag, ' '),
      value: tag,
    });
  });

  const default_commands = {
    drapcode_icons_custom_code: 'drapcode-icons:open-modal',
  };

  const default_refs = {
    drapcodeIconsRef: drapcodeIconsRef,
    keyDrapCodeIconsCustomCode: drapcodeIconsRef + '__code',
  };

  const default_labels = {
    drapcode_icons_custom_code: 'Icons Custom Code',
    buttonLabel: `<i class="fa fa-plus"></i> Add Icon`,
  };

  const default_titles = {
    buttonTitle: 'Add selected icon to canvas',
  };

  let defaults = {
    pfx: 'drapcode-icons',
    blocks: [drapcodeIconsRef],
    defaultStyle: true,
    label: 'Icons',
    category: 'Basic',
    refs: default_refs,
    commands: default_commands,
    labels: default_labels,
    titles: default_titles,
    tags: default_tags,
    blockDrapCodeIconsSectionCode: {},
    propsDrapCodeIconsSectionCode: {},
    placeholderContent: feather.icons['star'].toSvg({
      'data-gjs': drapcodeIconsRef + '-svg',
      'data-gjs-custom-name': 'Svg',
      'data-gjs-copyable': 'false',
      'data-gjs-removable': 'false',
      'data-gjs-selectable': 'false',
      'data-gjs-draggable': 'false',
      draggable: 'false',
    }),
    selectArrow: `<div class="gjs-d-s-arrow"></div>`,
    toolbarBtnDrapCodeIconsSectionCode: {},
    placeholderScript: `<div style="pointer-events: none; padding: 10px;">
      <svg viewBox="0 0 24 24" style="height: 30px; vertical-align: middle;">
        <path d="M13 14h-2v-4h2m0 8h-2v-2h2M1 21h22L12 2 1 21z"></path>
        </svg>
      Icon with <i>&lt;script&gt;</i> can't be rendered on the canvas
    </div>`,
    modalTitle: 'Icons',
    codeViewOptions: {},
    commandDrapCodeIconsSectionCode: {},
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
  loadCommands(editor, options);
});
